import React from "react";
import { Div, Image, Text, StyleReset } from "atomize";
import { Link } from "gatsby";
import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import Swiper from "react-id-swiper";
import SolvedModal from "../../modals/SolvedModal";
import SolvedSwiper from "../common/SolvedSwiper";

const params = {
  slidesPerView: 5.4,
  spaceBetween: 15,
  autoHeight: true,
  mousewheel: {
    forceToAxis: true,
    invert: true,
  },
  breakpoints: {
    1920: {
      slidesPerView: 6.4,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 5.4,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 5.4,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    320: {
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
  },
};

class PricingSolvedSlider extends React.Component {
  render() {
    const { title, items } = this.props;

    return (
      <Div>
        <WebsiteContainer>
          <CustomContainer>
            <Div
              textSize={{ xs: "caption4", md: "subheader3" }}
              p={{ t: { xs: "4rem", md: "3.5rem" } }}
              textWeight="600"
              textAlign={{ xs: "center", md: "left" }}
              tag="h2"
            >
              {title}
            </Div>
          </CustomContainer>
        </WebsiteContainer>
        <Div maxW="68.75rem" m="0.8rem auto 0">
          <SolvedSwiper items={items} />
        </Div>
      </Div>
    );
  }
}

export default PricingSolvedSlider;
